import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"

const PreviewPathDivider = ({ pathItem }) => {
  return (
    <div>
      <Text.H5 inverted>{pathItem.name}</Text.H5>
    </div>
  )
}

PreviewPathDivider.displayName = "PreviewPathDivider"

PreviewPathDivider.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default PreviewPathDivider
